import React, { Component } from 'react';
import '../../style/common-style.css';
import '../../style/login.css';
import {connect} from 'react-redux';
import * as Constants from '../common/Constants';
import Success from '../success/Success';
import * as Tagging from '../../tagging/LoginFormTagging';
import $ from "jquery";
import Loader from '../common/Loader';
import {resetStore} from "../common/Constants";
import { MainSection } from '../../CP-Redesign/Components/MainSection';
import { LoginAuth }from '../../CP-Redesign/Components/login/LoginAuth';
import { HeaderFooter }from '../common/HeaderFooter';
import styled from 'styled-components';
import backgroundImage from '../../images/main-background.png';


const MainContainer = styled.div`
  width: 100%;
  height: 110vh;
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  padding: 0 !important;

  @-moz-document url-prefix() {
    height: ${(props) =>( props.currentPage === 'REGISTER' && props.regSecondPhase) && '962px'};
  }

  @media screen and (max-width:768px) {
  height: 100.5vh;
  background-image: none;
  background-color: #fff;
  }
`;
class Login extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isError : false,
            showCloseButton: true,
            isLoading: false,
            password:'',
            regSecondPhase: false
        };
        this.clearStore();
        this.setPassword = this.setPassword.bind(this);
        this.setRegSecondPhase = this.setRegSecondPhase.bind(this);
    }

    setRegSecondPhase(newValue) {
        this.setState({ regSecondPhase: newValue });
      }

    callFromChildPage = ( flag ) => {
        this.setState({
            ...this.state,
            isError : flag
        })
    }

    clearStore = () => {
        resetStore();
        this.props.onLoginSuccess("");
    }

    componentDidMount() {
        if (window.location.search !== null && window.location.search !== undefined) {
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('error') && urlParams.get('error') === "true") {
                Tagging.loginErrorEvent("Unfortunately we are having technical issues and working to resolve them as soon as possible");
                this.props.setErrorDetails("Unfortunately we are having technical issues and working to resolve them as soon as possible", "Please try again later.", Constants.LOGIN);
                this.setState({
                    ...this.state,
                    isError: true
                })
            } else {
                this.setState({
                    ...this.state,
                    isError: false
                })
            }
            this.props.setPageToBeDisplayed(Constants.LOGIN);
        }
    }

    showCloseBtn = (show) => {
        this.setState({
            showCloseButton: show
        })
    };

    showLoader = (show) => {
        this.setState({isLoading: show});
    }

    redirectToHome = () => {
        window.location.href = window.location.protocol + '//' + window.location.hostname + '/business/home';
        return false;
    };

    setPassword = (value) => {
        this.setState({
            ...this.state,
            password : value
        })
    };


    render() {
        $('input.btn-red, .btn-red, input.btn-white, .btn-white, .login-layout .sub-url span').click(function() {

            $('html, body').animate({
                scrollTop: $(".login-form").offset().top
              }, 500)
         });
        return (
            <>
                <HeaderFooter />
                <MainContainer currentPage={this.props.pageToBeDisplayed} regSecondPhase={this.state.regSecondPhase}>
                    {
                        (this.props.pageToBeDisplayed === Constants.REGISTER || this.props.pageToBeDisplayed === Constants.FORGET_PASSWORD 
                            || this.props.pageToBeDisplayed === Constants.FORGET_USERNAME || this.props.pageToBeDisplayed === Constants.FORGET_PASSWORD_CHANGE)
                        ?
                            <MainSection currentPage={this.props.pageToBeDisplayed} setCurrentPage={this.props.setPageToBeDisplayed} regSecondPhase={this.state.regSecondPhase} setRegSecondPhase={this.setRegSecondPhase}/>
                        : <>

                        { this.props.pageToBeDisplayed === Constants.LOGIN ?
                            <LoginAuth 
                                setAccountType={this.props.pageToBeDisplayed}
                                showCloseBtn={this.showCloseBtn}
                                isError={this.state.isError}
                                callFromChildPage={this.callFromChildPage}
                                showLoader={this.showLoader}
                                setPassword={this.setPassword}/>
                            : null
                        }
                    {this.state.isLoading ? <Loader /> : null}
                        <div className="parent-main-wrapper full-width">
                            <div className="loginComponent">
                                <div className={this.props.pageToBeDisplayed === Constants.REGISTER ?"login-layout form-onboarding":"login-layout form-login"}>
                                    {
                                        this.props.pageToBeDisplayed === Constants.SUCCESS ?
                                            <Success
                                                showCloseBtn={this.showCloseBtn}
                                                isError={this.state.isError}
                                                callFromChildPage={this.callFromChildPage}
                                                showLoader={this.showLoader}
                                                setPassword={this.setPassword}/>
                                            : null
                                    }

                                </div>
                            </div>
                        </div>
                        </>
                        }
                        </MainContainer>
            </>
            )
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onLoginSuccess: (username) => dispatch({ type: Constants.LOGIN_SUCCESS, username: username }),
        setPageToBeDisplayed: (pageToBeDisplayed) => dispatch({
            type: Constants.SET_PAGE_TOBE_DISPLAYED,
            payload: pageToBeDisplayed
        }),
        setErrorDetails: (errorMessage1, errorMessage2, errorFrom) => dispatch({
            type: Constants.SET_ERROR_DETAILS,
            payload: {
                errorMessage1: errorMessage1,
                errorMessage2: errorMessage2,
                errorFrom: errorFrom
            }
        }),
    }
};
const mapStateToProps = state => {
    return {
        pageToBeDisplayed: state.pageToBeDisplayed
    }
};
export default (connect(mapStateToProps, mapDispatchToProps)(Login));